import { render, staticRenderFns } from "./ExtrachargeModal.vue?vue&type=template&id=484d6315&scoped=true&"
import script from "./ExtrachargeModal.vue?vue&type=script&lang=js&"
export * from "./ExtrachargeModal.vue?vue&type=script&lang=js&"
import style0 from "./ExtrachargeModal.vue?vue&type=style&index=0&id=484d6315&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484d6315",
  null
  
)

export default component.exports